import store from "@/fstore";

export default store;
